<template>
    <div class="company-box">
        <div class="company-center-box">
            <div class="message">
                <div class="mobile-img"></div>
                <h4 class="title">CONTACT US</h4>
                <h3 class="caption">温州蓝鲸数字科技有限公司</h3>
                <h5 class="caption-title">Wenzhou Blue Whale Digital Technology Co. LTD</h5>
                <ul class="message-box">
                    <li class="message-item" v-for='(item,index) in myMessageData' :key='item.name'>
                        <span v-html='item.name'></span><span class="diss" v-html='item.center'></span></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Company',
        data() {
            return {
                myMessageData: [
                    {
                        name: '地址',
                        center: '温州龙湾区蒲州街道光电大厦1501室',
                    },
                    {
                        name: '公司电话',
                        center: '+86 150-5875-1461',
                    },
                    {
                        name: '商务咨询',
                        center: '+86-150-5875-1461 （凌经理)'
                    },
                    {
                        name: '邮箱',
                        center: 'roy@lanjingshuzi.com',
                    },
                    {
                        name: '微信',
                        center: 'lingxiansheng66',
                    }
                ]
            }
        }
    }
</script>
<style scoped>
    .company-box {
        padding-bottom: 286px;
    }

    .company-center-box {
        width: 70.9%;
        height: 900px;
        background: #666666 url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/stock-photo-72684347.jpg') no-repeat center;
        background-attachment: initial;
        background-size: cover;
        position: relative;
    }

    .message {
        padding: 51px 49px;
        position: absolute;
        top: 50%;
        right: -30%;
        min-width: 671px;
        min-height: 746px;
        background-color: #ffffff;
        transform: translate(0, -50%);
    }

    .title {
        font-size: 16px;
        font-weight: bold;
        line-height: 19px;
        color: rgba(51, 51, 51, 1);
        text-align: right;
    }

    .caption {
        font-size: 24px;
        font-weight: bold;
        line-height: 32px;
        color: rgba(51, 51, 51, 1);
        margin-top: 83px;
    }

    .caption-title {
        font-size: 16px;
        font-weight: 400;
        line-height: 32px;
        color: rgba(204, 204, 204, 1);
        margin-top: 10px;
    }

    .message-box {
        margin-top: 40px;
    }

    .message-item {
        display: grid;
        grid-template-columns: 64px 1fr;
        grid-column-gap: 78px;
    }

    .message-item {
        padding: 21px 0;
        border-top: 1px solid #E5E5E5;
    }

    .message-item:last-child {
        border-bottom: 1px solid #E5E5E5;
    }

    .message-item>span {
        font-size: 16px;
        font-weight: 400;
        line-height: 32px;
        color: rgba(51, 51, 51, 1);
    }

    @media(max-width: 995px) {
        .company-box {
            padding-bottom: 50px;
        }

        .company-center-box {
            width: 100%;
            height: auto;
            padding: 0%;
        }

        .message {
            padding: 0%;
            position: relative;
            min-width: auto;
            /* top: 0px; */
            right: 0%;
            transform: translate(0, 0);
            background-color: rgba(255, 255, 255, 1);
        }
        .caption {
        font-size: 24px;
        font-weight: bold;
        line-height: 133%;
        margin-top: 10px;
        padding: 0 5%;
        text-align: center;
    }
    .title{
        display: none;
    }
    .caption-title {
        font-size: 14px;
        line-height: 200%;
        margin-top: 10px;
        padding: 0 5%;
        text-align: center;
    }
    .message-box {
        margin-top: 10px;
        padding: 0% 5%;
    }
    .message-item {
        display: grid;
        grid-template-columns:1fr;
        grid-column-gap: 5%;
        justify-items: center;
        
    }
    .mobile-img{
            display: block;
            background: red url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/stock-photo-72684347.jpg') no-repeat center;
            background-size: cover;
            width: 100%;
            height: 50vw;
        }
        /* .message {
        padding: 51px 49px;
        position: absolute;
        top: 50%;
        right: -30%;
        min-width: 671px;
        min-height: 746px;
        background-color: #ffffff;
        transform: translate(0, -50%);
    } */
    }

    /* @media(max-width: 1023px) {
        .company-box {
        padding-bottom: 986px;
    }
        .company-center-box {
            width: 100%;
            height: 1300px;
            background: #666666 url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/stock-photo-72684347.jpg') no-repeat center;
            background-attachment: fixed;
            background-size: cover;
            position: relative;
        }

        .message {
            padding:5%;
            position: absolute;
            top: 50%;
            right:0;
            min-width: 100%;
            background-color: rgba(255,255,255,.98);
            transform: translate(0%, 0%);
        }

        .message-item {
            display: grid;
            grid-template-columns: 20% 80%;
            grid-column-gap: 78px;
        }

        .company-center-box {
            background-attachment: initial;
        }

        .title {
            font-size: 40px;
            font-weight: bold;
            line-height: 118%;
        }

        .caption {
            font-size: 75px;
            line-height: 133%;
        }

        .caption-title {
            font-size: 50px;
            line-height: 200%;
        }

        .message-item>span {
            font-size: 50px;
            font-weight: 400;
            line-height: 200%;
            color: rgba(51, 51, 51, 1);
        }
    }
    @media(max-width: 320px){
        .company-box {
        padding-bottom: 1386px;
    }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/contact/company.vue